import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Typography, useMediaQuery } from '@mui/material';
import ACSnackbar from '../../components/ACSnackbar';
import EmailImage from '../../images/mail-check-outlined.svg';
import { forgotPassword } from '../../services/Authentication';
import CardScene from '../../components/CardScene';
import CardFooter from '../../components/CardFooter';
import OopsWindow from '../Oops';

const useStyles = () => ({
  card: {
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: 'white',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    height: '350px',
    width: (isSM) => !isSM && '600px',
    paddingTop: '20px',
  },
  confirmationLabel: {
    maxWidth: '300px',
    textAlign: 'center',
    color: 'secondary.dark',
  },
  subtitle: {
    maxWidth: '400px',
    textAlign: 'center',
    color: 'secondary.dark',
  },
  emailCheckedImage: {
    height: '100px',
    width: '100px',
  },
});

const AdvisorConfirmation = () => {
  const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles(isSM);
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');
  const [isQueryParamCompliant] = useState(() => {
    return email !== null;
  });

  async function handleResendConfirmationEmailButton() {
    await forgotPassword(queryParams.get('email'), {
      workflow: 'signup',
    });
    setIsSnackbarVisible(true);
  }

  return (
    <>
      {isQueryParamCompliant ? (
        <>
          <Helmet>
            <title>{t('CONFIRMATION-HELMET-TITLE')}</title>
          </Helmet>
          <CardScene clearPaper>
            <div id="confirmation-card" style={classes.card}>
              <ACSnackbar
                id="confirmation-request-received-snackbar"
                text={t('CONFIRMATION-REQUEST-RECEIVED-LABEL')}
                onClose={() => setIsSnackbarVisible(false)}
                open={isSnackbarVisible}
              />
              <img
                alt={t('CONFIRMATION-EMAIL-CHECKED-IMAGE-ALT')}
                style={classes.emailCheckedImage}
                src={EmailImage}
              />

              <Typography sx={classes.confirmationLabel} variant="h2_old_font">
                {t('CONFIRMATION-LABEL', { email: queryParams.get('email') })}
              </Typography>

              <Typography sx={classes.subtitle} variant="h2_old_font">
                {t('CONFIRMATION-CLICK-EMAIL-LABEL')}
              </Typography>

              <CardFooter onClickFooter={handleResendConfirmationEmailButton} />
            </div>
          </CardScene>
        </>
      ) : (
        <OopsWindow />
      )}
    </>
  );
};

export default AdvisorConfirmation;
